/** Norske 5-bokstavers løsningsord (bokmål) – kun ord med nøyaktig 5 bokstaver */
export const SOLUTIONS_NO = [
  "andre", "anger", "anker", "annen", "appen", "areal", "armen", "avler", "baker", "banke",
  "baren", "båten", "bedre", "begge", "berge", "besøk", "bilen", "biter", "bjørn", "blåse",
  "bleke", "blitt", "boken", "bomme", "borde", "brann", "brede", "bruke", "bukse", "bunke",
  "byene", "bytte", "bærer", "bølge", "bøsse", "dagen", "damer", "dansk", "daten", "delen",
  "dette", "domen", "drepe", "dukke", "dusin", "dykke", "døren", "elven", "elske", "ender",
  "enkle", "ennå", "etapp", "fabel", "fager", "fakta", "falle", "fange", "farer", "farte",
  "faser", "feber", "ferie", "festa", "filen", "finne", "firma", "fiske", "flere", "flyte",
  "fokus", "folke", "foran", "forma", "foten", "frakt", "fugle", "fylke", "førte", "gange",
  "gaten", "gilde", "gjeld", "gjøre", "glade", "glede", "glimt", "grave", "grunn", "guden",
  "gulve", "halve", "hamre", "hanen", "harde", "havne", "hefte", "helst", "henge", "herre",
  "heste", "hilse", "holde", "hoppe", "hotel", "huske", "hylle", "høyre", "håpen", "hæren",
  "ilden", "indre", "ingen", "inner", "jakke", "jeger", "jevne", "jobbe", "jorda", "jubel",
  "julen", "kaffe", "kalde", "kamer", "kanal", "kappe", "karen", "kasse", "kaste", "katta",
  "kikke", "kilde", "kirke", "kjede", "kjære", "kjøle", "kjøpe", "kjøre", "klage", "klapp",
  "klebe", "klima", "klipp", "knapp", "knute", "koker", "konge", "konto", "korps", "korte",
  "krage", "krane", "krets", "kropp", "krype", "kunne", "kurve", "kvile", "lager", "lampe",
  "lande", "lange", "leder", "legge", "leken", "lenge", "lette", "liden", "ligne", "linje",
  "liste", "liten", "livet", "logge", "lokke", "lomme", "losen", "lover", "lukke", "lunge",
  "lyden", "lykke", "lytte", "lærer", "løfte", "lønne", "løper", "løser", "låner", "låsen",
  "maler", "mamma", "mange", "marin", "maske", "matte", "melde", "melon", "merke", "messe",
  "meter", "milde", "miljø", "minne", "minus", "miste", "mobil", "moden", "modus",
  "møbel", "naken", "navne", "nedre", "nekte", "nesen", "nisse", "norge", "notat", "nytte",
  "nøden", "offer", "oljen", "orden", "organ", "ormen", "pakke", "palle", "panel", "pappa",
  "parti", "passe", "peker", "penge", "piken", "plage", "plass", "pleie", "plikt", "pluss",
  "polen", "potte", "prakt", "press", "prins", "ramme", "range", "regne", "reise", "rekke",
  "renne", "rette", "ringe", "riste", "riske", "robot", "rolle", "roman", "rosen", "rotte",
  "runde", "rulle", "ruste", "rydde", "rykke", "røker", "rører", "saken", "salat", "samle",
  "scene", "seier", "selge", "senat", "serie", "sette", "siden", "sikre", "siste", "sitte",
  "skade", "skape", "skatt", "skole", "skudd", "skuff", "skyld", "skyte", "slags", "slipp",
  "slite", "smake", "smart", "smelt", "snakk", "snart", "spake", "spark", "speil", "spill",
  "spise", "sport", "sprut", "stakk", "stand", "stang", "start", "stein", "stikk", "stilt",
  "storm", "strek", "stuen", "stupe", "ståle", "suger", "suite", "super", "surfe", "suser",
  "svake", "svein", "svett", "sving", "syden", "sykle", "søken", "søler", "sålen", "tabbe",
  "takke", "taler", "tappe", "tegne", "teppe", "teste", "tette", "timer", "tisse", "titte",
  "tjene", "tomme", "toner", "toppe", "torsk", "total", "trekk", "trene", "trett", "trinn",
  "trist", "troll", "trøst", "tuben", "tulle", "tusen", "tvile", "tykke", "typer", "tøffe",
  "tømme", "tønne", "tørke", "tørst", "tåler", "ulike", "ulven", "under", "union", "unike",
  "urten", "vaken", "vakre", "vaske", "veien", "velge", "vende", "verdi", "verne", "vesen",
  "veske", "video", "vinke", "vinne", "virke", "visst", "vokse", "volle", "vonde", "vrake",
  "vugge", "væren", "væske", "våken", "våpen", "yngre", "æbler", "ørene", "ørken", "åbner",
  "ånden", "åpent",
];

export const getRandomSolutionNo = (): string => {
  const i = Math.floor(Math.random() * SOLUTIONS_NO.length);
  return SOLUTIONS_NO[i];
};
